export default "__VITE_ASSET__DYXrRVmb__"